import React, { Component } from 'react';
import face from './face.jpeg'
import flamingo from './flamingos.jpg'
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <div className="section">
            <div className="lhs">
              <img src={face} className="App-headshot" alt="headshot" />
              <h1>R.J. Assaly</h1>
            </div>
            <div className="rhs">
              <br></br>
              <br></br>
              <p className="short-bio">product guy and occasional talking head</p>
              <p>loves horology, fishing, flamingos & quantitative finance</p>
              <ul>
                <li><a
                  className='App-link'
                  href='mailto:me@rjassaly.com'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  email
                </a>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <a
                  className='App-link'
                  href='https://www.linkedin.com/in/rj-assaly-50b7b16a/'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  linkedin
                </a>
                
                </li>
                <li><a
                  className='App-link'
                  href='https://gitlab.com/jungleman999'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  gitlab
                </a>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <a
                  className='App-link'
                  href='https://github.com/starjassly'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  github&nbsp;&nbsp;
                </a></li>
              </ul>
            </div>
          </div>
        </header>
        <img src={flamingo} className='App-photo' alt='flamingo'/>
      </div>
    )
  }
}

export default App
